/**
 * Registry for named auto-generate functions.
 *
 * Domains can register custom generators for complex field auto-generation
 * that goes beyond what the template DSL can express.
 *
 * @example
 * ```ts
 * registerGenerator('invoice_code', (fields, params) => {
 *     const type = String(fields['type'] ?? '');
 *     const date = String(fields['date'] ?? '');
 *     return `${params.prefix}-${type}-${date}`;
 * });
 * ```
 */

export type GeneratorFn = (
    fields: Record<string, unknown>,
    params: Record<string, unknown>,
) => string | null;

const registry = new Map<string, GeneratorFn>();

export function registerGenerator(name: string, fn: GeneratorFn): void {
    registry.set(name, fn);
}

export function getGenerator(name: string): GeneratorFn | undefined {
    return registry.get(name);
}

export function hasGenerator(name: string): boolean {
    return registry.has(name);
}
